import { useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'

import Page from 'components/Page'
import CustomerSubscriptionForm from 'components/forms/CustomerSubscriptionForm'
import { getCustomerSubscriptions } from 'redux/actions/subscriptions'

const CustomerSubscriptionView = () => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const { state } = useLocation()
  const { customerSubscriptions, isGetLoading } = useSelector((s) => s.subscriptions)

  const numericId = Number(id)

  useEffect(() => {
    // ensure list is loaded in case user opens view directly
    if (!customerSubscriptions || customerSubscriptions.length === 0) {
      dispatch(
        getCustomerSubscriptions({
          take: 50,
          page: 1,
          search: null,
          sortType: 'CREATED_AT',
          sortOrder: 'DESC',
          filters: JSON.stringify({}),
        }),
      )
    }
  }, [dispatch, customerSubscriptions?.length])

  const subscription = useMemo(() => {
    if (state?.subscription) return state.subscription
    return customerSubscriptions.find((s) => s.id === numericId)
  }, [state, customerSubscriptions, numericId])

  if (!subscription) {
    return (
      <Page pageTitle="Customer Subscription" isGetLoading={isGetLoading}>
        <p style={{ marginTop: 8 }}>
          Subscription not found. Please open it from the list again.
        </p>
      </Page>
    )
  }

  return (
    <Page pageTitle={`Customer Subscription #${subscription.id}`} isGetLoading={isGetLoading}>
      <CustomerSubscriptionForm defaultValues={subscription} />
    </Page>
  )
}

export default CustomerSubscriptionView